<template>
  <div class="chooseResult" v-show="breadcrumb_show">
    <dl>
      <dt>已选：</dt>
      <dd>
        <ul>
          <li v-show="!value.model || value.model.length === 0" v-for="(condition,index) in value.brand_origin" :key="'brand_origin' + index" >
              <a href="javascript:;" @click="deselect('brand_origin',condition)">
              {{ options.origin_options.find(o => o.brandOriginId === condition).brandOriginName }}
              </a>
          </li>
          
          <div v-show="!value.model || value.model.length === 0" v-for="(conditions, index) in value.body_size" :key="'body_size' + index">
               <li v-if="conditions.global_size.length === 0">
                 <a href="javascript:;" @click="deselect('body_size',conditions.body_type)">
                   {{ options.body_size_options.find(o => o.bodyTypeId === conditions.body_type).bodyTypeName }}
                 </a>
               </li>
               <li v-for="(globalSizeId, index) in conditions.global_size" :key="'global_size' + index" @click="deselect(globalSizeId)">
                  <a href="javascript:;" @click="deselect('global_size',conditions.body_type,globalSizeId)">
                  {{ options.body_size_options.find(o => o.bodyTypeId === conditions.body_type).globalSizes.find(t => t.globalSizeId === globalSizeId ).globalSizeName}}
                  {{ options.body_size_options.find(o => o.bodyTypeId === conditions.body_type).bodyTypeName }}
                   </a>
              </li>
          </div>
         
          
          <li v-show="!value.model || value.model.length === 0"  v-for="(condition,index) in value.propulsion_type" :key="'propulsion_type' + index" >
              <a href="javascript:;" @click="deselect('propulsion_type',condition)">
              {{ options.propulsion_options.find(o => o.propulsionTypeId === condition).propulsionTypeName }}
              </a>
          </li>

          <li v-show="!value.model || value.model.length === 0" v-for="(condition,index) in value.manufacturer" :key="'manufacturer' +index" >
              <a href="javascript:;" @click="deselect('manufacturer',condition)">
              {{ options.manufacturer_options.find(o => o.manufacturerId === condition).vehicleManufacturer }}
              </a>
          </li>

          <li v-show="!value.model || value.model.length === 0" v-for="(condition,index) in value.brand" :key="'brand' +index" >
              <a href="javascript:;" @click="deselect('brand', condition)">
              {{ options.brand_options.find(o => o.brandId === condition).brandName }}
              </a>
          </li>

          <li v-show="value.model && value.model.length > 0" v-for="(condition,index) in value.model" :key="'model' +index" >
              <a href="javascript:;" @click="deselect('model', condition)">
              {{ options.model_options.find(o => o.modelLines.indexOf(condition) >= 0).brand.brandName + ' ' + condition }}
              </a>
          </li>

        </ul>
      </dd>
    </dl>
  </div>
</template>

<script>
export default {
  name: "breadcrumb",
  props: {
    value: Object,
    options: Object,
    
  },
  data() {
    return {
      breadcrumb_show: false
    };
  },
  computed: {
      
  },
  watch: {
      value(new_val){
        let keys = Object.keys(new_val);
        for(let i = 0; i < keys.length; i++){
          if(Array.isArray(new_val[keys[i]])){
            if(new_val[keys[i]] && new_val[keys[i]].length > 0){
              this.breadcrumb_show = true;
              break;
            }
          }
          this.breadcrumb_show = false;
        }
        // if((new_val.body_size && new_val.body_size.length === 0) && new_val.brand.length === 0 && new_val.brand_origin.length === 0 
        // && new_val.manufacturer.length === 0 && new_val.model.length === 0 && new_val.propulsion_type.length === 0){
        //   this.breadcrumb_show = false;
        // }else
        // {
        //   this.breadcrumb_show = true;
        // }
      },
  },
  mounted() {
  },
  methods: {
    deselect(condition_type,choiced_value,attach){
        // console.log(this.options)
        this.$emit('deselect', condition_type, choiced_value ,attach); 
        this.$emit('filter');
        
    }
  },
};
</script>